import { Pickup as IconPickup } from '@ahamove/icons/map';
import { getAddressLabels } from '@ahm/api-wrappers-core';
import { FloatingLabelInput } from '@ahm/react-ui';
import { Button, Stack, Text, rem } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import type { PathRecipientInfo, PathSenderInfo } from './types';

interface FormData {
  sender: PathSenderInfo;
  recipient: PathRecipientInfo;
}

export function PickupFormSection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormData>();

  return (
    <Stack gap={rem(16)}>
      <Controller
        name="sender.address"
        control={control}
        render={({ field: { value } }) => {
          const [firstLabel] = getAddressLabels(value ?? '');
          return (
            <Button
              variant="light"
              fullWidth
              h="auto"
              leftSection={<IconPickup />}
              disabled
              styles={{
                root: { padding: rem(12) },
                label: { whiteSpace: 'normal', textAlign: 'left', flex: 1 },
              }}
            >
              <Stack align="flex-start" gap={4}>
                <Text size="sm" fw={700} c="neutral.7" lineClamp={1}>
                  {firstLabel}
                </Text>
                <Text size="xs" c="neutral.5" lineClamp={1} fw={500}>
                  {value}
                </Text>
              </Stack>
            </Button>
          );
        }}
      />
      <Controller
        name="sender.remarks"
        control={control}
        render={({ field: { onChange, value } }) => (
          <FloatingLabelInput
            label="Ghi chú địa chỉ gửi"
            value={value}
            onChange={(e) => onChange(e)}
            h="auto"
          />
        )}
      />
      <Controller
        name="sender.name"
        control={control}
        render={({ field: { onChange, value } }) => (
          <FloatingLabelInput
            label="Tên người gửi"
            h="auto"
            value={value}
            onChange={onChange}
            error={errors.sender?.name?.message}
          />
        )}
      />
      <Controller
        name="sender.mobile"
        control={control}
        render={({ field: { onChange, value } }) => (
          <FloatingLabelInput
            label="Số điện thoại người gửi"
            h="auto"
            value={value}
            onChange={onChange}
            error={errors.sender?.mobile?.message}
          />
        )}
      />
    </Stack>
  );
}
